// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.SensorData_chart-view__-WK-f {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
}
@media (max-width: 1024px) {
  .SensorData_chart-view__-WK-f {
    display: flex;
    flex-direction: column;
  }
}
.SensorData_chart-view__-WK-f {
  gap: 1rem;
}
.SensorData_chart-view__-WK-f .SensorData_sidebar__Dc-H4 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (min-width: 1024px) {
  .SensorData_chart-view__-WK-f .SensorData_sidebar__Dc-H4 {
    min-width: 23rem;
    max-width: 23rem;
  }
}
.SensorData_chart-view__-WK-f .SensorData_sidebar__Dc-H4 .SensorData_sidebar-block__JUwLk {
  padding: 1rem;
  padding-bottom: 1rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: space-evenly;
  background-color: #333;
  color: white;
  border-radius: 0.3rem;
}

.SensorData_amchart__EhSGN {
  width: 100%;
  display: flex;
  height: 35rem;
  justify-content: center;
}

.SensorData_cogs__eoF3Z {
  position: relative;
}
.SensorData_cogs__eoF3Z button {
  background-color: rgba(255, 255, 255, 0);
  border: None;
  outline: None;
}
.SensorData_cogs__eoF3Z button i {
  background-color: #7b7b7b;
  padding: 0.3rem;
  border-radius: 0.3rem;
  color: white;
  font-size: 1rem;
}
.SensorData_cogs__eoF3Z button i:hover {
  cursor: pointer;
}

.SensorData_chart-button__Iu\\+gr {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.3rem;
  border-width: 0rem;
  outline: none;
  transition-duration: 0.3s;
  font-size: 100%;
  color: white;
  background: #333;
}

.SensorData_chart-button__Iu\\+gr:hover {
  background: #286090;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/utils/_base.scss","webpack://./src/containers/SensorData.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AClCA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACSJ;ADPI;EACI,YAAA;EACA,aAAA;ACSR;ADNI;EACI,gBAAA;ACQR;;ADHA,uBAAA;AAQA,mBAAA;ACtBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAsBF;AFmCE;EE7DF;IAMI,aAAA;IACA,sBAAA;EAwBF;AACF;AAhCA;EAUE,SAAA;AAyBF;AAvBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAyBJ;AF4BE;EExDA;IAMI,gBAAA;IACA,gBAAA;EA0BJ;AACF;AAxBI;EACE,aAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBDZM;ECaN,YAAA;EACA,qBAAA;AA0BN;;AArBA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAwBF;;AArBA;EACE,kBAAA;AAwBF;AAtBE;EACE,wCAAA;EACA,YAAA;EACA,aAAA;AAwBJ;AAtBI;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAwBN;AAtBM;EACE,eAAA;AAwBR;;AAlBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EAEA,eAAA;EACA,qBAAA;EACA,kBAAA;EAEA,aAAA;EAEA,yBAAA;EAEA,eAAA;EACA,YFzEkB;EE2ElB,gBDhEU;ACgFZ;;AAbA;EACE,mBFlFsB;AEkGxB","sourcesContent":[null,null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.chart-view {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  width: 100%;\n}\n@media (max-width: 1024px) {\n  .chart-view {\n    display: flex;\n    flex-direction: column;\n  }\n}\n.chart-view {\n  gap: 1rem;\n}\n.chart-view .sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n@media (min-width: 1024px) {\n  .chart-view .sidebar {\n    min-width: 23rem;\n    max-width: 23rem;\n  }\n}\n.chart-view .sidebar .sidebar-block {\n  padding: 1rem;\n  padding-bottom: 1rem;\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  justify-content: space-evenly;\n  background-color: #333;\n  color: white;\n  border-radius: 0.3rem;\n}\n\n.amchart {\n  width: 100%;\n  display: flex;\n  height: 35rem;\n  justify-content: center;\n}\n\n.cogs {\n  position: relative;\n}\n.cogs button {\n  background-color: rgba(255, 255, 255, 0);\n  border: None;\n  outline: None;\n}\n.cogs button i {\n  background-color: #7b7b7b;\n  padding: 0.3rem;\n  border-radius: 0.3rem;\n  color: white;\n  font-size: 1rem;\n}\n.cogs button i:hover {\n  cursor: pointer;\n}\n\n.chart-button {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 0.3rem;\n  border-width: 0rem;\n  outline: none;\n  transition-duration: 0.3s;\n  font-size: 100%;\n  color: white;\n  background: #333;\n}\n\n.chart-button:hover {\n  background: #286090;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart-view": `SensorData_chart-view__-WK-f`,
	"sidebar": `SensorData_sidebar__Dc-H4`,
	"sidebar-block": `SensorData_sidebar-block__JUwLk`,
	"amchart": `SensorData_amchart__EhSGN`,
	"cogs": `SensorData_cogs__eoF3Z`,
	"chart-button": `SensorData_chart-button__Iu+gr`
};
export default ___CSS_LOADER_EXPORT___;
